import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  .footer {
    &__links {
      ${bp('sm')`
        display: inline-block;
      `}
      li {
        line-height: 1.4;
        ${bp('sm')`
          line-height: 1.5;
        `}
      }
    }

    &__certs {
      margin-top: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      li {
        padding: 0 5px;
      }

      ${bp('sm')`
        display: inline-flex;
        flex-direction: column;
        align-items: flex-start;

        li {
          text-align: left;
          margin: 2px 0;
        }
      `}
    }

    &__links,
    &__certs {
      ${bp('sm')`
        width: 49%;
        vertical-align: top;
        margin-top: 0;
      `}
    }
  }
`
